import React from "react";
import { Box, IconButton } from "@mui/material";
import VideoCallIcon from "@assets/icons/videoCallIcon";
import AudioCallIcon from "@assets/icons/audioCallIcon";
import {useDispatch} from "react-redux";
import {AppDispatch} from "@store/store";
import {initiateCall} from "@store/callSlice";
import { useHasPolicy } from "@config/useHasPolicy";
import { PolicyEnum } from "@config/policyEnum";

interface AudioAndVideoCallProps {
  customStatus: string;
  ticketId: string | undefined;
}
 
const AudioAndVideoCall: React.FC<AudioAndVideoCallProps> = ({
                                                                 customStatus,
                                                                 ticketId,
                                                             }) => {
    const showVideoCallIcon = useHasPolicy(PolicyEnum.VIEW_CHAT_VIDEO_ICON);
    const showAudioCallIcon = useHasPolicy(PolicyEnum.VIEW_CHAT_AUDIO_ICON);
    const editVideoCallIcon = useHasPolicy(PolicyEnum.EDIT_CHAT_VIDEO_ICON);
    const editAudioCallIcon = useHasPolicy(PolicyEnum.EDIT_CHAT_AUDIO_ICON);
    const dispatch = useDispatch<AppDispatch>();
    const handleCall = (isVideoOn: boolean) => {
        dispatch(
            initiateCall({
                ticketId: ticketId,
                hasVideo: isVideoOn,
                startCall: true
            })
        );
    };

    if (customStatus === "Closed") return <></>;

    return (
        <Box className="flex gap-3 sm:gap-4">
            {showVideoCallIcon &&
            <IconButton className="cursor-pointer" onClick={() => handleCall(true)} disabled={ticketId === 'new' || !editVideoCallIcon}>
                <VideoCallIcon/>
            </IconButton>}
            {showAudioCallIcon &&
            <IconButton className="cursor-pointer" onClick={() => handleCall(false)} disabled={ticketId === 'new' || !editAudioCallIcon}>
                <AudioCallIcon/>
            </IconButton>}
        </Box>
    );
};
 
export default AudioAndVideoCall;